@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  user-select: none !important;
  opacity: 0;
  pointer-events: none;

  @include media-breakpoint-down("md") {
    padding: 0.6rem;
  }
}

.root * {
  user-select: none !important;
}

.root--is-visible {
  opacity: 1;

  @media (hover: none) {
    pointer-events: all;
  }
}

.inner {
  padding: var(--spacer-2);
  border-radius: 0.625rem;
  font-size: 1rem;
  width: 8rem;
  will-change: transform;
  display: flex;
  flex-direction: column;
  width: auto;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  text-align: center;
  color: var(--color-bright-green);
  background: var(--color-swamp-green);
  transform: translate(-50%, -50%);
  @include typo--small-label();
}

.root svg {
  margin-bottom: 0.5rem;
  width: 2rem;
  height: auto;

  @include media-breakpoint-down("md") {
    margin-bottom: 0.4rem;
  }
}

.root svg path {
  fill: var(--color-bright-green);
}
